<template>
  <div
    class="sm:max-auto mt-6 flex flex-wrap gap-2 sm:absolute sm:bottom-2.5 sm:left-0 sm:right-0 sm:mt-0 sm:justify-center sm:gap-4 lg:bottom-10 3xl:bottom-14"
  >
    <div
      v-for="(item, i) in items"
      :key="i"
      class="point title flex h-8 min-w-[113px] items-center justify-center rounded-lg text-left text-[0.688rem] uppercase leading-none text-slate-lighten4 backdrop-blur-md sm:h-16 sm:min-w-[160px] sm:p-4 sm:text-sm sm:text-white"
    >
      <div
        v-if="item.icon"
        class="pointer-events-none mr-2 h-8 w-8 flex-shrink-0 flex-grow-0 sm:mr-4"
      >
        <object
          class="h-full w-full object-contain"
          :data="getIcon(item)"
        ></object>
      </div>

      <span class="whitespace-pre-line tracking-[0.12em]" v-html="item.text" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useBreakpoint, useMediaAsset } from '~/composables';

interface Props {
  items?: any[];
}

withDefaults(defineProps<Props>(), {
  items: () => [],
});

const { getAssetUrl } = useMediaAsset();
const { isBiggerThanBreakpoint: isBiggerSm } = useBreakpoint('sm');

const getIcon = (item: any) =>
  getAssetUrl(isBiggerSm.value ? item.icon?.desktop : item.icon?.mobile) ??
  undefined;
</script>

<style lang="sass" scoped>
.point
  @media (min-width: 768px)
    background: linear-gradient(180deg, rgba(126, 126, 126, 0.24) 0%, rgba(187, 187, 187, 0.16) 100%)
</style>
